import type { SymptomCheckerInterviewData } from 'constants/_types/SymptomCheckerInterviewData';

const validateReportData = (reportData: SymptomCheckerInterviewData): boolean => {
  if (!reportData.evidence) return false;
  return true;
};

export default validateReportData;
